import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'

const options: InitOptions = {
    fallbackLng: 'rus',
    ns: ['translations'],
    defaultNS: 'translations',

    // To investigate react-i18next translation issues enable this
    debug: false,

    interpolation: {
        escapeValue: false,
    },

    react: {
        useSuspense: false,
    },
}

i18n.use(initReactI18next).init(options)
export default i18n
